export class ParametersVariations {

    private readonly variantIdx: string;
    private readonly configureAll: any;
    private readonly session: any;
    private readonly itemIdx: any;
    private readonly loadItemVariants: any;

    constructor(variantIdx: string, configureAll: any, session: any, itemIdx: any, loadItemVariants: any) {
        this.variantIdx = variantIdx;
        this.configureAll = configureAll;
        this.session = session;
        this.itemIdx = itemIdx;
        this.loadItemVariants = loadItemVariants;
    }

    // Some variant types (e.g. "width") deliver their image as a plain filename string
    // instead of the usual {filename: ...} object other variant types (e.g. "height") use,
    // so this resolves either shape to the actual filename.
    private static getImageFilename(image: any): string {
        return typeof image === 'string' ? image : image?.filename;
    }

    public getItemVariants(itemIdx: number, newVariantIdx: string = "", variantIdxAddon: string = "") {
        if (!this.session.value && this.session.value.items && this.session.value.items[itemIdx])
            return []

        const variantIdx = newVariantIdx || this.variantIdx;

        const variants = []

        const firstItemVariants = this.session.value.items[itemIdx].variants || {};


        for (const key in firstItemVariants) {
            const variant = firstItemVariants[key];
            if (!variant?.idx) continue;

            let checkVariantId = variant.idx
            const parts = variant.idx.split('.');

            if (parts.length == 3 && !isNaN(parts[1]) && variantIdx.indexOf(".*.") > -1) {
                parts[1] = "*"
                checkVariantId = parts.join('.')
            }


            if (variantIdx != checkVariantId) continue;

            if (variant.values.length === 0) this.loadItemVariants(itemIdx, variant.idx, variantIdxAddon);

            variants.push(
                variant
            )
        }

        return variants
    }

    public getVariants(variantIdxAddon: string = "") {
        if (!this.session.value && this.session.value.items)
            return []

        const startIdx = this.configureAll.value ? 0 : this.itemIdx.value

        const firstItemVariants = this.getItemVariants(startIdx, "", variantIdxAddon)

        if (!this.configureAll.value)
            return firstItemVariants

        const otherItemVariants: any[] = []
        if (this.session.value && this.session.value.items) {
            for (const itemIdx in this.session.value.items) {
                if (parseInt(itemIdx.toString()) === parseInt(startIdx.toString())) continue
                otherItemVariants.push(this.getItemVariants(parseInt(itemIdx.toString()), "", variantIdxAddon))
            }
        }

        for (const key in firstItemVariants) {
            // go through discs of first item
            const variant = firstItemVariants[key];

            // search the same disc in other items of session
            for (const otherItemIdx in otherItemVariants) {

                for (const otherVariantIdx in otherItemVariants[otherItemIdx]) {
                    if (variant.idx === otherItemVariants[otherItemIdx][otherVariantIdx].idx) {
                        // disc of first item found in another item of the session!

                        // now compare values of found idx and if value.idx for variant exists in otherItemVariants[otherItemIdx][otherVariantIdx].values[].idx add
                        for (const firstValueIdx in variant.values) {

                            for (const itemValueIdx in otherItemVariants[otherItemIdx][otherVariantIdx].values) {
                                if (variant.values[firstValueIdx].idx.toString() === otherItemVariants[otherItemIdx][otherVariantIdx].values[itemValueIdx].idx.toString()) {

                                    if (typeof variant.values[firstValueIdx]["items"] == "undefined")
                                        variant.values[firstValueIdx]["items"] = []

                                    const filename = ParametersVariations.getImageFilename(otherItemVariants[otherItemIdx][otherVariantIdx].values[itemValueIdx].image)
                                    if (!variant.values[firstValueIdx]["items"].includes(filename)) {
                                        variant.values[firstValueIdx]["items"].push(filename)
                                    }
                                    break
                                }
                            }
                        }
                        break
                    }
                }
            }
        }

        return firstItemVariants
    }

    public imageUrl(colorVariantsOfDisc: any, hoverColorIdx: number, otherItemsImages?: string[]) {
        if (hoverColorIdx !== -1 && colorVariantsOfDisc.length >= hoverColorIdx && colorVariantsOfDisc[hoverColorIdx]) {
            if (this.configureAll.value) {
                let items: string[] = []
                if (otherItemsImages && otherItemsImages.length > 0) {
                    items = otherItemsImages
                } else if (colorVariantsOfDisc[hoverColorIdx].items && colorVariantsOfDisc[hoverColorIdx].items.length > 0) {
                    items = colorVariantsOfDisc[hoverColorIdx].items
                } else {
                    for (const idx in this.session.value.items) {
                        if (parseInt(idx) !== 0) {
                            items.push(this.session.value.items[idx].image.filename)
                        }
                    }
                }

                let setImage = ParametersVariations.getImageFilename(colorVariantsOfDisc[hoverColorIdx].image).replace("item/image/", "item/image/set/");

                for (const itemImage of items) {
                    const filenameParts = itemImage.split("/");
                    setImage += `/${filenameParts[filenameParts.length - 1]}`;
                }

                return setImage;
            } else {
                if (colorVariantsOfDisc[hoverColorIdx]) {
                    return ParametersVariations.getImageFilename(colorVariantsOfDisc[hoverColorIdx].image).replace("item/image/", "item/image/upright/") + "/1000";

                }
            }
        }

        if (this.session.value.items && this.session.value.items[this.itemIdx.value]) {
            if (this.configureAll.value) {
                const items: string[] = []
                for (const idx in this.session.value.items) {
                    if (parseInt(idx) !== 0) {
                        items.push(this.session.value.items[idx].image.filename)
                    }
                }

                let setImage = this.session.value.items[this.itemIdx.value].image.filename.replace("item/image/", "item/image/set/");

                for (const itemImage of items) {
                    const filenameParts = itemImage.split("/");
                    setImage += `/${filenameParts[filenameParts.length - 1]}`;
                }

                return setImage;
            } else {
                return this.session.value.items[this.itemIdx.value].image.filename || ''
            }
        }
        return ''
    }
}
